import * as React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { observer } from 'src/utils/mobx-react';
import { ConfigComponents } from '../../config/features/config';
import { RollingDepositLimitPopup } from 'src/domains/players/webview/components/RollingDepositLimitPopup';
import { DepositLimitUpdatePopup } from 'src/domains/players/state/accountState/DepositLimitsUpdatePopups/DepositLimitUpdatePopup/DepositLimitUpdatePopup';
import { MonthlyActivityPopup } from 'src/domains/layouts/webview/components/popups/monthlyActivityPopup/monthlyActivityPopup';
import { BonusEnginePopup } from 'src/domains/layouts/webview/components/popups/bonusEnginePopup/BonusEnginePopup';
import { BetslipBonusPopup } from 'src/domains/sportsbook/betting/ui/betSlip/betslipBonus/BetslipBonusPopup';
import { useAppStateContext } from 'src/appState/AppState';
import { UsersState } from 'src/domains/players/state/UsersState';

export const PopupsWithStartApp = observer('PopupsWithStartApp', () => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;
    const { appSportsBookState } = useAppStateContext();
    const { betSlipState } = appSportsBookState;
    const usersState = UsersState.get(common);

    const { rollingNetDepositLimit, bonusEngine } = config;

    return (
        <>
            {rollingNetDepositLimit === true ? <RollingDepositLimitPopup /> : null}
            {rollingNetDepositLimit === true ? <DepositLimitUpdatePopup /> : null}
            {usersState.isMonthlyActivityPopupOpen === false ? null : <MonthlyActivityPopup />}
            {bonusEngine === true ? <BonusEnginePopup /> : null}
            {betSlipState.isBonusPopupOpen && betSlipState.basicBetSlipState.channel === 'quickbet' ? (
                <BetslipBonusPopup />
            ) : null}
        </>
    );
});
